import { observer, useLocalObservable } from "mobx-react";
import { Avatar, Badge, Collapse, Divider, List, Modal } from "antd";
import { translateKey as t } from "../../../../../../locales/translation";
import { ClientsController } from "../../../ClientsController";
import { AppStore } from "~/stores/AppStore";
import { useEffect } from "react";
import type { CollapseProps } from "antd";
import { CloseCircleOutlined } from "@ant-design/icons";
import _ from "lodash";

const ErrorsModal = observer(({ store, controller }: { store?: AppStore; controller?: ClientsController }) => {
  useEffect(() => {});

  const state = useLocalObservable(() => ({
    get groupedValues() {
      const { postDataErrors, preDataErrors } = controller.dataImporterModal;

      let groupedData = {};

      if (preDataErrors.length > 0) {
        preDataErrors.forEach((recordList) => {
          recordList.forEach((record) => {
            const { sheetName, id } = record;
            if (!groupedData[sheetName]) {
              groupedData[sheetName] = {};
            }
            if (!groupedData[sheetName][id]) {
              groupedData[sheetName][id] = [];
            }
            groupedData[sheetName][id].push(record);
          });
        });
      } else if (postDataErrors.length > 0) {
        groupedData = postDataErrors.reduce((acc, item) => {
          if (!acc[item.sheetName]) {
            acc[item.sheetName] = [];
          }
          acc[item.sheetName].push({
            error: item.message,
            ref: item.ref,
            data: item.data,
          });
          return acc;
        }, {});
      }

      return groupedData;
    },
  }));
  const { formatText } = controller;

  if (!controller.importerErrorsModal.visible) {
    return null;
  }

  const handleClose = () => {
    controller.setImporterErrorsModal(null, {
      visible: false,
    });
  };

  const renderPreItems = (items) => {
    let content;
    const itemArray = Object.values(items);
    let rowNumber = "N/A";

    content = (
      <List
        itemLayout="horizontal"
        size="small"
        dataSource={itemArray}
        renderItem={(items: any, index) => {
          let itemContent = [];

          items.forEach((err) => {
            rowNumber = err.rowNumber;

            itemContent.push(
              <li>
                {formatText(err.ref)}: {err.message}
              </li>
            );
          });

          return (
            <List.Item>
              <List.Item.Meta avatar={<CloseCircleOutlined />} title={`Row ${rowNumber}`} description={<ul>{itemContent}</ul>} />
            </List.Item>
          );
        }}
      />
    );
    return content;
  };

  const renderPostItems = (items) => {
    let content;
    content = (
      <List
        itemLayout="horizontal"
        size="small"
        dataSource={items}
        renderItem={(item: any, index) => (
          <List.Item>
            <List.Item.Meta avatar={<CloseCircleOutlined />} title={item.ref + ": " + item.data} description={item.error} />
          </List.Item>
        )}
      />
    );
    return content;
  };

  const renderItems = (items) => {
    const { postDataErrors, preDataErrors } = controller.dataImporterModal;

    if (preDataErrors.length > 0) {
      return renderPreItems(items);
    } else if (postDataErrors.length > 0) {
      return renderPostItems(items);
    }
  };

  const renderWorksheetErrors = () => {
    let items: CollapseProps["items"] = [];

    Object.entries(state.groupedValues).map(([key, records]: any, index) => {
      items.push({
        key: `${key}_${index}`,
        label: formatText(key),
        children: renderItems(records),
        extra: <Badge count={_.size(records)} />,
      });
    });

    return items;
  };

  return (
    <Modal
      title={t("lblErrors", "Errors")}
      open={controller.importerErrorsModal.visible}
      cancelText={t("lblClose", "Close")}
      onCancel={handleClose}
      centered={true}
      okType="primary"
      maskClosable={false}
      footer={null}
      styles={{ body: { height: "80vh", padding: 10, overflow: "auto" } }}
      className="errorModal"
    >
      <Collapse items={renderWorksheetErrors()} />
    </Modal>
  );
});

export default ErrorsModal;
